import { InfiniteScroll, usePage } from '@inertiajs/react'
import { useRef } from 'react'
import { PageProps as InertiaPageProps } from '@inertiajs/core'
import { MediaAttachmentCard } from './Admin/AttachmentGroups/MediaAttachmentCard'

interface PageProps extends InertiaPageProps {
  attachments: any
}

export default function OldMediaSection() {
  const { props } = usePage<PageProps>()
  const { attachments } = props
  const infiniteScrollRef = useRef<any>(null)

  const { data, meta } = attachments

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const target = e.currentTarget
    const scrolledToBottom = target.scrollHeight - target.scrollTop <= target.clientHeight + 100

    if (scrolledToBottom && infiniteScrollRef.current) {
      infiniteScrollRef.current.fetchNext()
    }
  }

  return (
    <div style={{
      backgroundColor: 'var(--color-base-300)',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: '20px 100px',
      gap: '50px'
    }}>
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        alignItems: 'center',
        overflow: 'hidden',
        color: 'var(--color-neutral)',
      }}>
        <h1 className="text-4xl font-bold">
          Media
        </h1>
        <div style={{
          width: '100%',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          maxWidth: '1400px',
          margin: '0 auto',
          gap: '4px',
        }}>
          <p
            className="text-2xl font-bold"
          >
            Messes précédentes ({meta.total_count})
          </p>
          <InfiniteScroll
            ref={infiniteScrollRef}
            data="attachments"
            manual
            preserveUrl
            onScroll={handleScroll}
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
              gap: '8px',
              maxHeight: '600px',
              overflowY: 'auto'
            }}
          >
            {data.map((attachment: any) => (
              <MediaAttachmentCard
                key={`attachment-${attachment.id}`}
                attachment={attachment}
                href={`/admin/attachments/${attachment.id}`}
              />
            ))}
          </InfiniteScroll>
        </div>
      </div>
    </div>
  )
}
